import React from 'react'
import { version as appVersion } from '../../package.json'

export default () => {
  return (
    <div className='ui bottom fixed menu'>
      <div className='item'>
        App version:&nbsp;{ appVersion }
        {process.env.NODE_ENV !== 'production' &&
          <span style={{ color: 'red' }}>&nbsp;{process.env.NODE_ENV}</span>
        }
      </div>
      <div className="right menu">
        <div className="item">
          &copy; Matt Sharp Design 2018 - 2021
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/AppFooter.js